import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { AuthGuardOrganizer } from 'src/auth/guard/auth-guard';
import { GiveawayLiveDrawSlotMachine, GiveawayResultSlotMachine } from 'src/sections/giveaway-menu/view';

// OVERVIEW
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const ProductDetailsPage = lazy(() => import('src/pages/dashboard/product/details'));
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
// UserssPage
const GiveawayPage = lazy(() => import('src/pages/dashboard/giveaway'));
const CreateNewGiveawayPage = lazy(() => import('src/pages/dashboard/createNewGiveaway'));
const EditingGiveawayPage = lazy(() => import('src/pages/dashboard/editGiveaway'));
// ----------------------------------------------------------------------

export const admindashboardRoutes = [
  {
    path: 'organizer-dashboard',
    element: (
      <AuthGuardOrganizer>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuardOrganizer>
    ),
    children: [
      { element: <OverviewEcommercePage />, index: true },
      {
        path: 'giveaway',
        children: [
          { element: <GiveawayPage />, index: true },
          { path: 'new', element: <CreateNewGiveawayPage /> },
          { path: ':id/edit', element: <EditingGiveawayPage /> },
          { path: 'detail/:id', element: <ProductDetailsPage /> },
          { path: 'live-draw/:id', element: <GiveawayLiveDrawSlotMachine /> },
          { path: "result/:id", element: <GiveawayResultSlotMachine /> },
        ]
      },
      {
        path: 'organizer',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
        ],
      },
    ],
  },
];
